import { reactive } from 'vue';

export interface Toast {
  id: number;
  tone: 'success' | 'danger' | 'info';
  message: string;
}

const state = reactive<{ toasts: Toast[] }>({ toasts: [] });
let nextId = 1;

function push(tone: Toast['tone'], message: string, timeoutMs: number): void {
  const id = nextId;
  nextId += 1;
  state.toasts.push({ id, tone, message });
  setTimeout(() => {
    dismiss(id);
  }, timeoutMs);
}

function dismiss(id: number): void {
  const index = state.toasts.findIndex((toast) => toast.id === id);
  if (index !== -1) state.toasts.splice(index, 1);
}

/** Short confirmations and errors shown in a corner of the screen. Render `<UiToaster />` once. */
export function useToast(): { toasts: Toast[]; success: (message: string) => void; error: (message: string) => void; info: (message: string) => void; dismiss: (id: number) => void } {
  return {
    toasts: state.toasts,
    success: (message) => {
      push('success', message, 3500);
    },
    error: (message) => {
      push('danger', message, 7000);
    },
    info: (message) => {
      push('info', message, 3500);
    },
    dismiss,
  };
}
